{
  "edit": {
    "page_title": "Edit Availability",
    "submit": "Update Availability"
  },
  "form": {
    "availability": {
      "section_title": "Availability",
      "no_availability": "No availability specified. Please select the times on the calendar or use the form above to specify when you will be available for consultations.",
      "availability_notes": "Availability Notes",
      "overlapping_error": "The time you selected overlaps with another time slot.",
      "invalid_error": "The time you selected is invalid.",
      "day": "Day",
      "start_time": "Start Time",
      "end_time": "End Time",
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "sunday": "Sunday"
    }
  }
}
